export default (data, schema) => {
    return Object.keys(data).reduce((newData, key) => {
        if (
            schema.properties?.[key]?.type?.[0] === 'array' &&
            schema.properties?.[key]?.items?.type === 'integer' &&
            Array.isArray(data[key]) &&
            data[key] &&
            data[key].length
        ) {
            newData[key] = data[key].map((d) => d.value);
        } else if (data?.[key]?.value || data?.[key]?.value === 0) {
            newData[key] = data[key].value;
        }

        return newData;
    }, data);
};
